import { render, staticRenderFns } from "./MobileFrame.vue?vue&type=template&id=67d419b3&"
import script from "./MobileFrame.vue?vue&type=script&lang=js&"
export * from "./MobileFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports